module.exports = __webpack_public_path__ + "media/images/admin/icons/plus-circle-6ccef3018bcc6d53d56e94a66618a0c0.svg";